
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var isKeyframesTarget = function (v) {
    return Array.isArray(v);
};

export { isKeyframesTarget };
//# sourceMappingURL=is-keyframes-target.mjs.js.map
